import * as React from 'react';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import { BakeasyChip, BakeasyChipDelete } from '../common/BakeasyChip';
import { t } from 'i18next';
import BakeasyLinkButton from '../buttons/BakeasyLinkButton';
import { useEffect, useState } from 'react';
import { GRAY_200 } from '../../constants/Colors';
import { BakeasyTableCell } from './tableCell/BakeasyTableCell';
import BakeasyTextField from '../textfields/BakeasyTextField';
import * as Regex from '../../constants/Regex';
import * as TextField from '../textfields/BakeasyTextFields';
import { ValidateInput } from '../../utils/ValidationUtils';
import { getCurrency } from '../../utils/commonUtils';
import { storeState } from '../../redux_store/slices/storeSlice';
import { useAppSelector } from '../../redux_store/reduxStore';
import { OrderHistoryState } from '../../redux_store/slices/OrderHistorySlice';
interface Data {
  id: number;
  name: string;
  emailId: string;
  mobile: string;
  status: JSX.Element;
  actions: JSX.Element[];
  storeId: string;
  storeName: string;
  supplierName: string;
  addressCity: string;
  tag: string;
  price: number;
  category: string;
  subCategory: string;
  orderId: string;
  totalPrice: number;
  expectedDate: string;
  deliveryDate: string;
  productName: string;
  contact: string;
  recipeBuilder: string;
  duplicate: string;
  dateCreated: string;
  lastOrderDate: string;
  totalOrders: string;
  totalOrderValue: string;
  ingredientName: string;
  measureType: string;
  units: string;
  nutritionName: string;
  dailyvalue: string;
  dateTime: string;
  From: string;
  To: string;
  recsent: string;
  Content: string;
  Priority: string;
  subject: string;
  lastAccess: string;
  stores: string;
  products: string;
  edit: string;
  supplierId: string;
}

export interface HeadCell {
  disablePadding?: boolean;
  id: number | keyof Data | string;
  label?: string;
  numeric?: boolean | false;
  isChip?: boolean | false;
  sort?: boolean | false;
}

interface BakeasyTableToolbarProps {
  numSelected: number;
}

interface BakeasySimpleTableMainProps {
  headers?: any[];
  headCells?: any[];
  tableData: any;
  rowProps?: number;
  pageNo?: number;
  navigate?: any;
  count?: any;
  refreshPage?: any;
  refreshPageData?: any;
  api?: string;
  openDeleteConfirmDialog?: any;
  type?: string;
  data?: any;
  status?: any;
}

const BakeasySimpleTable = React.forwardRef(
  (
    props: BakeasySimpleTableMainProps,
    ref: React.ForwardedRef<{
      handleChangePage: (event: unknown, newPage: number) => void;
      onDeleteRow: (id: number) => void;
    }>
  ) => {
    const { headers, tableData, openDeleteConfirmDialog } = props;
    const [tableDataList, setTableDataList] = useState<any>([]);
    const [isEdit, setIsEdit] = useState<boolean>(false);

    let _storeState = useAppSelector(storeState);
    let _fetchOrderHistoryById = useAppSelector(OrderHistoryState);

    const handleQuantityChange = (index: number, value: any) => {
      const updatedTableDataList = [...tableDataList];
      updatedTableDataList[index].quantity = Number(value);
      updatedTableDataList[index].totalprice = (
        Number(value) * Number(updatedTableDataList[index].unitPrice)
      ).toFixed(2);
      Number(updatedTableDataList[index].totalprice);
      setTableDataList(updatedTableDataList);
    };

    useEffect(() => {
      setTableDataList(tableData);
    }, [tableData]);

    const openDeleteConfirmDialogbox = (id: any) => {
      openDeleteConfirmDialog(id);
    };

    const calculateTotalPrice = () => {
      let totalPrice = tableDataList.reduce(
        (total: any, order: { totalprice: string }) => {
          return total + parseFloat(order.totalprice);
        },
        0
      );
      return totalPrice.toFixed(2);
    };

    function CustomTableCell(
      id: any,
      disabled: boolean | false,
      row: any,
      index: any
    ) {
      switch (id) {
        case 'name':
          return (
            <BakeasyLinkButton
              label={row[id]}
              style={{ fontWeight: 'bold' }}
              onClick={row['onNameClick']}
            />
          );
        case 'contact':
          return (
            <BakeasyLinkButton
              label={row[id]}
              onClick={row['onContactClick']}
            />
          );
        case 'quantity':
          if (!disabled) {
            return (
              <BakeasyTextField
                label={''}
                type="text"
                placeHolder={''}
                name="quantity"
                required={false}
                value={row.quantity}
                maxLength={4}
                style={{ height: '35px' }}
                regexPattern={Regex.quantity}
                onChange={(event: any) => {
                  const newValue = event.target.value;
                  const formattedValue =
                    newValue.length > 0
                      ? newValue.startsWith('0') && newValue !== '0'
                        ? newValue.slice(1)
                        : newValue
                      : '0';

                  if (!ValidateInput(Regex.quantity, formattedValue)) {
                    return false;
                  }
                  handleQuantityChange(index, formattedValue);
                }}
              />
            );
          } else {
            return row.quantity;
          }
        // case 'quantity':
        //   if (row.isEdit) {
        //     return (
        //       <TextField.Quantity
        //         disabled={disabled}
        //         type="number"
        //         value={row.quantity}
        //         onChange={(e: any) => handleQuantityChange(index, e.target.value)}
        //       />
        //     );
        //   } else {
        //     return row.quantity;
        //   }
        case 'productName':
          if (row['status']?.toLowerCase() === 'cancelled') {
            return (
              <>
                {row[id]}
                {<BakeasyChip label={row['status']} />}
              </>
            );
          }
          return row[id];
        case 'confirmedQuantity':
          if (!disabled) {
            return (
              <TextField.Quantity
                label={''}
                disabled={row?.cancelOrderChecked}
                value={row.confirmedQuantity}
                onChange={(event: any) => {
                  if (parseInt(event.target.value)) {
                    handleQuantityChange(row, event.target.value);
                  } else {
                    handleQuantityChange(row, 0);
                  }
                }}
              />
            );
          } else {
            return row[id];
          }
        case 'totalPrice':
        case 'unitPrice':
          return Number(row[id])?.toFixed(2);
        case 'actions':
          return (
            <BakeasyChipDelete
              onClick={() => openDeleteConfirmDialogbox(row.productId)}
            />
          );
        default:
          return row[id];
      }
    }

    function getHeaderLabel(header: any) {
      switch (header?.id) {
        case 'unitPrice':
        case 'totalprice':
        case 'totalPrice':
        case 'price':
          return t(header?.label) + getCurrency(_storeState?.value);
        default:
          return t(header?.label);
      }
    }
    return (
      <Box sx={{ width: '100%' }}>
        <Paper sx={{ width: '100%' }}>
          <TableContainer>
            <Table
              stickyHeader
              sx={{ minWidth: 500 }}
              aria-labelledby="tableTitle"
            >
              <TableHead>
                <TableRow>
                  {headers?.map((header, index) => (
                    <TableCell
                      style={{
                        padding: 10,
                        backgroundColor: GRAY_200,
                        width: header.width ? header.width : 'auto',
                        textAlign: header?.numeric ? 'right' : header.align,
                        maxWidth: '400px',
                      }}
                      key={index}
                    >
                      <Typography style={{ fontWeight: 'bold' }}>
                        {getHeaderLabel(header)}
                      </Typography>
                      {/* <Typography style={{ fontWeight: 600 }}>{t(header.label)}</Typography> */}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {tableDataList?.map((row: any, index: any) => (
                  <>
                    <TableRow key={index}>
                      {headers?.map((header, headerIndex) => (
                        <TableCell
                          style={{
                            padding: 10,
                            width: header.width ? header.width : 'auto',
                            textAlign: header?.numeric ? 'right' : header.align,
                            maxWidth: '400px',
                          }}
                          key={headerIndex}
                        >
                          {CustomTableCell(
                            header.id,
                            header.disabled,
                            row,
                            index
                          )}
                        </TableCell>
                      ))}
                    </TableRow>
                  </>
                ))}
              </TableBody>

              {props?.type === 'createOrder' && (
                <>
                  <TableRow>
                    <TableCell colSpan={2} />
                    <BakeasyTableCell
                      colSpan={2}
                      style={{ padding: 2 }}
                      value={t('TOTAL_ORDER_VALUE')}
                    />
                    <BakeasyTableCell value={calculateTotalPrice()} />
                  </TableRow>
                </>
              )}

              {props?.type === 'orderSummary' && (
                <>
                  <TableRow>
                    <TableCell colSpan={3} />
                    <BakeasyTableCell value={t('SUB_TOTAL')} />
                    <BakeasyTableCell
                      value={props?.data?.calculatedsubTotal?.toFixed(2)}
                    />
                  </TableRow>

                  <TableRow>
                    <TableCell colSpan={2} />
                    <BakeasyTableCell
                      colSpan={2}
                      value={
                        (_storeState?.value &&
                          (_storeState.value as any)?.taxes?.rate1) ||
                        ''
                      }
                      // value={t('ESTIMATED_TAXES_1')}
                    />
                    <BakeasyTableCell
                      value={props?.data?.calculatedtax1?.toFixed(2)}
                    />
                  </TableRow>

                  <TableRow>
                    <TableCell colSpan={2} />
                    <BakeasyTableCell
                      colSpan={2}
                      value={(_storeState?.value as any)?.taxes?.rate2}
                    />
                    <BakeasyTableCell
                      value={props?.data?.calculatedtax2?.toFixed(2)}
                    />
                  </TableRow>

                  <TableRow>
                    <TableCell colSpan={2} />
                    <BakeasyTableCell
                      colSpan={2}
                      value={
                        (_storeState?.value as any)?.shippingRateType ===
                        'Percentage'
                          ? t('SHIPPING_CHARGE_PERCENTAGE')
                          : (_storeState?.value as any)?.shippingRateType ===
                              'Amount'
                            ? t('SHIPPING_CHARGE_AMOUNT')
                            : (_storeState?.value as any)?.shippingRateType
                      }
                    />
                    <BakeasyTableCell
                      value={props?.data?.calculatedshippingCharge?.toFixed(2)}
                    />
                  </TableRow>

                  <TableRow>
                    <TableCell colSpan={3} />
                    <BakeasyTableCell value={t('TOTAL')} />
                    <BakeasyTableCell
                      value={props?.data?.calculatedtotal?.toFixed(2)}
                    />
                  </TableRow>
                </>
              )}

              {props?.type === 'orderDetails' &&
                props?.status?.toLowerCase() !== 'cancelled' && (
                  <>
                    <TableRow>
                      <TableCell colSpan={4} />
                      <BakeasyTableCell value={t('SUB_TOTAL')} />
                      <BakeasyTableCell
                        value={props?.data?.calculatedsubTotal?.toFixed(2)}
                      />
                    </TableRow>

                    <TableRow>
                      <TableCell colSpan={3} />
                      <BakeasyTableCell
                        colSpan={2}
                        value={(_storeState?.value as any)?.taxes?.rate1}
                      />
                      <BakeasyTableCell
                        value={props?.data?.calculatedtax1?.toFixed(2)}
                      />
                    </TableRow>

                    <TableRow>
                      <TableCell colSpan={3} />
                      <BakeasyTableCell
                        colSpan={2}
                        value={(_storeState?.value as any)?.taxes?.rate2}
                      />
                      <BakeasyTableCell
                        value={props?.data?.calculatedtax2?.toFixed(2)}
                      />
                    </TableRow>

                    <TableRow>
                      <TableCell colSpan={3} />
                      <BakeasyTableCell
                        colSpan={2}
                        value={
                          (_storeState?.value as any)?.shippingRateType ===
                          'Percentage'
                            ? t('SHIPPING_CHARGE_PERCENTAGE')
                            : (_storeState?.value as any)?.shippingRateType ===
                                'Amount'
                              ? t('SHIPPING_CHARGE_AMOUNT')
                              : (_storeState?.value as any)?.shippingRateType
                        }
                      />
                      <BakeasyTableCell
                        value={props?.data?.calculatedshippingCharge?.toFixed(
                          2
                        )}
                      />
                    </TableRow>

                    <TableRow>
                      <TableCell colSpan={4} />
                      <BakeasyTableCell value={t('TOTAL')} />
                      <BakeasyTableCell
                        value={props?.data?.calculatedtotal?.toFixed(2)}
                      />
                    </TableRow>
                  </>
                )}

              {props?.type === 'invoiceDetails' && (
                <>
                  <TableRow>
                    <TableCell colSpan={4} />
                    <BakeasyTableCell value={t('SUB_TOTAL')} />
                    <BakeasyTableCell
                      value={props?.data?.calculatedsubTotal?.toFixed(2)}
                    />
                  </TableRow>

                  <TableRow>
                    <TableCell colSpan={3} />
                    <BakeasyTableCell
                      colSpan={2}
                      value={(_storeState?.value as any)?.taxes?.rate1}
                    />
                    <BakeasyTableCell
                      value={props?.data?.calculatedtax1?.toFixed(2)}
                    />
                  </TableRow>

                  <TableRow>
                    <TableCell colSpan={3} />
                    <BakeasyTableCell
                      colSpan={2}
                      value={(_storeState?.value as any)?.taxes?.rate2}
                    />
                    <BakeasyTableCell
                      value={props?.data?.calculatedtax2?.toFixed(2)}
                    />
                  </TableRow>

                  <TableRow>
                    <TableCell colSpan={3} />
                    <BakeasyTableCell
                      colSpan={2}
                      value={
                        (_storeState?.value as any)?.shippingRateType ===
                        'Percentage'
                          ? t('SHIPPING_CHARGE_PERCENTAGE')
                          : (_storeState?.value as any)?.shippingRateType ===
                              'Amount'
                            ? t('SHIPPING_CHARGE_AMOUNT')
                            : (_storeState?.value as any)?.shippingRateType
                      }
                    />
                    <BakeasyTableCell
                      value={props?.data?.calculatedshippingCharge?.toFixed(2)}
                    />
                  </TableRow>

                  <TableRow>
                    <TableCell colSpan={4} />
                    <BakeasyTableCell value={t('TOTAL')} />
                    <BakeasyTableCell
                      value={props?.data?.calculatedtotal?.toFixed(2)}
                    />
                  </TableRow>
                </>
              )}

              {props?.type === 'shippingDetails' && (
                <>
                  <TableRow>
                    <TableCell colSpan={4} />
                    <BakeasyTableCell value={t('SUB_TOTAL')} />
                    <BakeasyTableCell
                      value={props?.data?.calculatedsubTotal?.toFixed(2)}
                    />
                  </TableRow>

                  <TableRow>
                    <TableCell colSpan={3} />
                    <BakeasyTableCell
                      colSpan={2}
                      value={(_storeState?.value as any)?.taxes?.rate1}
                    />
                    <BakeasyTableCell
                      value={props?.data?.calculatedtax1?.toFixed(2)}
                    />
                  </TableRow>

                  <TableRow>
                    <TableCell colSpan={3} />
                    <BakeasyTableCell
                      colSpan={2}
                      value={(_storeState?.value as any)?.taxes?.rate2}
                    />
                    <BakeasyTableCell
                      value={props?.data?.calculatedtax2?.toFixed(2)}
                    />
                  </TableRow>

                  <TableRow>
                    <TableCell colSpan={3} />
                    <BakeasyTableCell
                      colSpan={2}
                      value={
                        (_storeState?.value as any)?.shippingRateType ===
                        'Percentage'
                          ? t('SHIPPING_CHARGE_PERCENTAGE')
                          : (_storeState?.value as any)?.shippingRateType ===
                              'Amount'
                            ? t('SHIPPING_CHARGE_AMOUNT')
                            : (_storeState?.value as any)?.shippingRateType
                      }
                    />
                    <BakeasyTableCell
                      value={props?.data?.calculatedshippingCharge?.toFixed(2)}
                    />
                  </TableRow>

                  <TableRow>
                    <TableCell colSpan={4} />
                    <BakeasyTableCell value={t('TOTAL')} />
                    <BakeasyTableCell
                      value={props?.data?.calculatedtotal?.toFixed(2)}
                    />
                  </TableRow>
                </>
              )}
            </Table>
          </TableContainer>
        </Paper>
      </Box>
    );
  }
);

export default BakeasySimpleTable;
